import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useCallback } from 'react';
import { useTheme } from '../../../../../theme';
import ModalConfirm, { ModalConfirmProps } from '../../../../../ModalConfirm/components/ModalConfirm';

interface Props extends ModalConfirmProps {
	redirectURL: string;
	open?: boolean;
}

const Warning: React.FC<Props> = ({ open, onClose, redirectURL }) => {
	const { Warning: css } = useTheme('Checkout');
	const { t } = useTranslation('Checkout');
	const onClick = useCallback(() => (window.location.href = redirectURL), [redirectURL]);

	return (
		<ModalConfirm
			size="medium"
			isOpen={open}
			onClose={onClose}
			title={t('Next step')}
			confirmBtn={t('Continue')}
			onConfirm={onClick}
		>
			<div className={css.text}>
				{t(
					'Now you will be redirected to the previous version of the site. There you can choose ancillary services.'
				)}
			</div>
		</ModalConfirm>
	);
};

export default Warning;
